/* -------------------------------------------------------------------------- */
/*                                Dialog styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-dialog.variables';

:host {
  @apply invisible #{!important};
}

:host(.bq-dialog--open) {
  @apply visible #{!important};
}

/* --------------------------------- Dialog --------------------------------- */

.bq-dialog {
  @apply fixed flex flex-col gap-[--bq-dialog--content-footer-gap] p-b-0 p-i-0;
  @apply bg-[--bq-dialog--background] text-[--bq-dialog--text-color] shadow-[shadow:--bq-dialog--box-shadow];
  @apply rounded-[--bq-dialog--border-radius] border-[length:--bq-dialog--border-width] border-[color:--bq-dialog--border-color];
  // If mobile resolution, dialog will be full width
  @apply is-[90vw];

  border-style: var(--bq-dialog--border-style);

  &.small {
    @apply sm:is-[--bq-dialog--width-small];
  }

  &.medium {
    @apply sm:is-[--bq-dialog--width-medium];
  }

  &.large {
    @apply sm:is-[--bq-dialog--width-large];
  }
}

/* ----------------------------- Dialog backdrop ---------------------------- */

.bq-dialog::backdrop {
  @apply bg-[--bq-dialog--background-backdrop] opacity-0 transition-[opacity] duration-300 ease-in-out;
}

.bq-dialog[open]::backdrop {
  @apply opacity-60;
}

/* ------------------------------ Dialog header ----------------------------- */

.bq-dialog--header {
  @apply sticky flex items-center gap-m p-b-[--bq-dialog--padding] p-be-0 p-i-[--bq-dialog--padding] inset-bs-0;
}

/* ------------------------------ Dialog footer ----------------------------- */

.bq-dialog--footer {
  @apply sticky flex items-center justify-end gap-xs is-full p-b-[--bq-dialog--padding] p-bs-0 p-i-[--bq-dialog--padding] inset-bs-[100%];
}
